import React, { useState, useEffect } from "react";
import axios from "axios";
import "./UserStats.css";

const API_HOST = process.env.REACT_APP_API_URL;

const UserStats = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sortBy,setSortBy] = useState("total");
  const [sortOrder, setSortOrder] = useState("desc");

  useEffect(() => {
    fetchUserStats();
  }, []);

  const fetchUserStats = async () => {
    const authToken = sessionStorage.getItem("authToken");
    try {
      const response = await axios.get(`${API_HOST}blogs/stats/by-user`, {
        headers: { "auth-token": authToken },
      });
      setUsers(response.data.users);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching user stats:", err);
      setError("Failed to load user statistics");
      setLoading(false);
    }
  };

  const handleSort = (column) => {
    if (sortBy === column) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortBy(column);
      setSortOrder("desc");
    }
  };

  const sortedUsers = [...users].sort((a, b) => {
    const multiplier = sortOrder === "asc" ? 1 : -1;
    return (a[sortBy] - b[sortBy]) * multiplier;
  });

  if (loading) {
    return <div className="user-stats-loading">Loading user statistics...</div>;
  }

  if (error) {
    return <div className="user-stats-error">{error}</div>;
  }

  return (
    <div className="user-stats-container">
      <h2>👥 Blog Stats by Author</h2>
      
      {users.length === 0 ? (
        <p className="no-data">No blog data available yet.</p>
      ) : (
        <div className="user-stats-table-wrapper">
          <table className="user-stats-table">
            <thead>
              <tr>
                <th onClick={() => handleSort("creator")} className="sortable">
                  Author {sortBy === "creator" && (sortOrder === "asc" ? "↑" : "↓")}
                </th>
                <th onClick={() => handleSort("total")} className="sortable">
                  Total {sortBy === "total" && (sortOrder === "asc" ? "↑" : "↓")}
                </th>
                <th onClick={() => handleSort("last7Days")} className="sortable">
                  7 Days {sortBy === "last7Days" && (sortOrder === "asc" ? "↑" : "↓")}
                </th>
                <th onClick={() => handleSort("last30Days")} className="sortable">
                  30 Days {sortBy === "last30Days" && (sortOrder === "asc" ? "↑" : "↓")}
                </th>
                <th onClick={() => handleSort("publicCount")} className="sortable">
                  Public {sortBy === "publicCount" && (sortOrder === "asc" ? "↑" : "↓")}
                </th>
                <th onClick={() => handleSort("privateCount")} className="sortable">
                  Private {sortBy === "privateCount" && (sortOrder === "asc" ? "↑" : "↓")}
                </th>
              </tr>
            </thead>
            <tbody>
              {sortedUsers.map((user, index) => (
                <tr key={index}>
                  <td className="author-name">
                    <div className="author-avatar">{user.creator.charAt(0).toUpperCase()}</div>
                    {user.creator}
                  </td>
                  <td className="stat-total">{user.total}</td>
                  <td>{user.last7Days}</td>
                  <td>{user.last30Days}</td>
                  <td className="stat-public">{user.publicCount}</td>
                  <td className="stat-private">{user.privateCount}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default UserStats;
